import { motion, useReducedMotion } from 'framer-motion';

export default function IllustrationMotion({
  src,
  alt = 'Empty',
  maxHeight = 300,
  noBorder = false,
  icon = '🫥',
  className = '',
  tone = 'primary',
}) {
  const reduceMotion = useReducedMotion();

  if (src) {
    const entrance = reduceMotion ? {} : { opacity: 1, y: 0 };
    const initial = reduceMotion ? undefined : { opacity: 0, y: 8 };
    const floatAnimate = reduceMotion ? {} : { y: [0, -8, 0] };
    const floatTransition = reduceMotion
      ? {}
      : { duration: 6, ease: 'easeInOut', repeat: Infinity };

    return (
      <motion.div
        className={`illustration-motion ${className}`.trim()}
        initial={initial}
        animate={entrance}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        aria-hidden="true"
      >
        <motion.img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
          style={{
            maxHeight: `${maxHeight}px`,
            width: 'auto',
            height: 'auto',
            opacity: 0.92,
          }}
          className={noBorder ? '' : `border border-${tone} rounded-4`}
          animate={floatAnimate}
          transition={floatTransition}
        />
      </motion.div>
    );
  }

  return (
    <div
      className={`illustration-motion illustration-motion--${tone} ${className}`.trim()}
      aria-hidden="true"
    >
      <div className="illustration-motion__halo" />
      <div className="illustration-motion__card">
        <span className="illustration-motion__icon">{icon}</span>
      </div>
    </div>
  );
}
